/**
 * @file useSearchParams.ts
 * @author markJia(markjia@tencent.com)
 * @desc
 */

import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { useMemo } from 'react';

export const useSearchParams = () => {
  const location = useLocation();

  const paramsObj = useMemo(() => qs.parse(location.search.slice(1)), [location]);

  return {
    searchParamStr: location.search.slice(1),
    searchParamObj: paramsObj,
  };
};
